<div class="container" [ngClass]="{'container-large': size==='large', 'container-medium': size==='medium', 'container-small': size==='small', 'container-form': size==='form'}"><ng-content></ng-content></div>
